// extracted by mini-css-extract-plugin
module.exports = {"container":"personalManagement_container__2yRKT","contentMain":"personalManagement_contentMain__eDkvA"};